import ReactGA from 'react-ga4';
import { Routes, Route, BrowserRouter as Router } from 'react-router-dom';

import { GlobalErrorBoundary } from '@/components/GlobalErrorBoundary';
import { NavigateToDefaultRoute } from '@/components/NavigateToDefaultRoute';
import { CSRF_TIMEOUT } from '@/constants';
import { useTimeoutReload } from '@/hooks/useTimeoutReload';
import { ConsentGroup } from '@/services/consentService';
import { consentService } from '@/services/instance/consentService';
import { discoveryService } from '@/services/instance/discovery';
import { ga4SettingsService } from '@/services/instance/ga4SettingsService';
import { DriftLoaderProvider, DriftLoaderButton } from '@/site/components/DriftLoader';
import { DriftPageHelper } from '@/site/components/DriftPageHelper';
import { HeadedPage } from '@/site/components/HeadedPage';
import { LoginPage } from '@/site/pages/Login';
import { RegisterPage } from '@/site/pages/Register';
import {
    RestoreStartPage,
    RestoreUpdatePage,
    RestoreCancelledPage,
    RestoreFailedPage,
    SetPasswordPage,
} from '@/site/pages/Restore';
import { SamlErrorPage } from '@/site/pages/SamlErrorPage';
import { SelectSamlProviderPage } from '@/site/pages/SelectSamlProvider';

const noop = () => {};

const headerProps: HeadedPage.Props['headerProps'] = {
    logoLink: discoveryService.get('site'),
    onLogoClick: noop,
};

const tryInitGA = () => {
    if (consentService.hasConsent([ConsentGroup.Performance])) {
        const ga4id = ga4SettingsService.getId();

        ReactGA.initialize([
            {
                trackingId: ga4id,
            },
        ]);
    }

    window.removeEventListener('onConsentDataLoaded', tryInitGA);
};

window.addEventListener('onConsentDataLoaded', tryInitGA);

export function App() {
    useTimeoutReload(CSRF_TIMEOUT);

    return (
        <GlobalErrorBoundary>
            <Router>
                <DriftLoaderProvider providerKey={'ufukwg49vzmb'}>
                    <HeadedPage headerProps={headerProps}>
                        <Routes>
                            <Route
                                path="/login"
                                element={<LoginPage />}
                            />
                            <Route
                                path="/register"
                                element={<RegisterPage />}
                            />
                            <Route
                                path="/restore-password"
                                element={<RestoreStartPage />}
                            />
                            <Route
                                path="/restore-password-cancelled"
                                element={<RestoreCancelledPage />}
                            />
                            <Route
                                path="/restore-password-failed"
                                element={<RestoreFailedPage />}
                            />
                            <Route
                                path="/restore-password-update"
                                element={<RestoreUpdatePage />}
                            />
                            <Route
                                path="/set-password"
                                element={<SetPasswordPage />}
                            />
                            <Route
                                path="/sso-login"
                                element={<SelectSamlProviderPage />}
                            />
                            <Route
                                path="/api/saml/consume-assertion/:idp"
                                element={<SamlErrorPage />}
                            />
                            <Route
                                path="/api/saml/login/:idp"
                                element={<SamlErrorPage />}
                            />
                            <Route
                                path="*"
                                element={<NavigateToDefaultRoute />}
                            />
                        </Routes>
                    </HeadedPage>
                    <DriftLoaderButton />
                </DriftLoaderProvider>
                <DriftPageHelper />
            </Router>
        </GlobalErrorBoundary>
    );
}
